import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, HostBinding, Input, Output, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';
import { UserListModel } from '@modules/admin/_models/user-list.model';
import { UserDataModel } from '@modules/auth';

@Component({
  selector: 'app-user-avatar',
  templateUrl: './user-avatar.component.html',
  styleUrls: ['./user-avatar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserAvatarComponent {
  @Input() user?: UserDataModel | UserListModel;
  @Input() size = 40;
  @Input() icon?: string;

  @Output() clicked: EventEmitter<void> = new EventEmitter();

  @HostBinding('class.no-click')
  @Input() preventClick: boolean;

  @HostBinding('attr.style')
  public get hostSize(): string {
    return `height: ${this.size}px; width: ${this.size}px;`
  }

  constructor(
    private router: Router
  ) {}

  public customAvatarStyle = {
    borderRadius: "50%",
    objectFit: "cover",
  };

  public clickOnAvatar() {
    if (this.preventClick) return;
    
    this.clicked.next();
    this.router.navigateByUrl(`/user-profile/user/${this.user?.id}`)
  }
}
